import type { Locale } from "@do/shared-types";

export const localeToFlag = (locale: Locale) => {
  const transformedLocale = locale.toLowerCase().substring(0, 2);
  if (transformedLocale === "en") return "gb";
  return transformedLocale;
};
